import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Especie } from "../model/especie.model";

@Injectable({
  providedIn: "root",
})
export class EspecieService {
  baseUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) { }

  getAll(): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'species';
    const _url = _baseUrl + _route;
    return this.httpClient.get<any>(`${_url}`);
  }


}
